/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */

import api, {
  multiPartHeader, 
  partHeader, 
  apiInternal,
  apiFiles
 } from '../../api';

const FileDownload = require('js-file-download');

const state = {
  all: [],
  params: [],
  quizz: [],
};

const getters = {
  paramsByModuId: (state, getters) => id => state.params[id],
};

const actions = {
  async getParamsModule({  commit }, moduId) {

    const result = await api.post(`${apiInternal}/getAllowedParams`,moduId ,partHeader);
    if (result) commit('setParamsModule', { moduId, params: result.data});
    return result;
  },
  async updateModuleOrder({ state, commit }, params) {
   const result = await api.post(`${apiInternal}/updateModuleOrder`,params ,partHeader);
    return result;
  },
  async addModuleName({ state, commit }, params) {
   const result = await api.post(`${apiInternal}/addModuleName`,params ,partHeader);
    return result;
  },
  async addModuleParams({ state, commit }, params) {
   const result = await api.post(`${apiInternal}/addModuleParams`,params ,partHeader);
    return result;
  },
  async updateMiniQuiz({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/updateMiniQuiz`,params ,partHeader);
    return result;
  },
  async updateQuestion({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/updateQuestion`,params ,partHeader);
    return result;
  },
  async changeQuizStatus({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/changeQuizStatus`,params ,partHeader);
    return result;
  },
  async importQuiz({ state, commit }, formList) {
    const result = await api.post(`${apiInternal}/importQuiz`,formList ,multiPartHeader);
    return result;
  },
  async exportQuiz({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/exportQuiz`,params ,{ ...partHeader, ...{responseType: 'blob'} });
    if (result) FileDownload(result.data, 'Données quiz.zip');    
    return result;
  },
  async updateQuestionWithImage({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/updateQuestionWithImage`,params ,multiPartHeader);
    return result;
  },
  async setMiniQuiz({ state, commit }, formList) {
    const result = await api.post(`${apiInternal}/setMiniQuiz`,formList ,multiPartHeader);
    return result;
  },
  async getMiniQuizz({ state, commit }) {
    const result = await api.post(`${apiInternal}/getMiniQuizz`,{} ,partHeader);
    if (result) commit('setMiniQuizz', result.data);
    return result;
  },

  async getBase64Image({ state, commit }, assId) {
    const result = await api.post(`${apiFiles}/GetBase64File`,{ id: [assId], source: 'dmasset' } ,partHeader);
    return result;
 },
};

const mutations = {
  setParamsModule(state, { moduId, params }) {
    state.params.push(moduId.modu_id);
    state.params[moduId] = params;
  },
  setMiniQuizz(state, quizz) {
    state.quizz = quizz;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
